var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.5,
    height: 21.5,
    viewBox: "0 0 19.5 21.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar-2",
    transform: "translate(-2.25 -1.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_213",
    "data-name": "Group 213"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M8,5.75A.755.755,0,0,1,7.25,5V2a.75.75,0,0,1,1.5,0V5A.755.755,0,0,1,8,5.75Z",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M16,5.75A.755.755,0,0,1,15.25,5V2a.75.75,0,0,1,1.5,0V5A.755.755,0,0,1,16,5.75Z",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M20.5,9.84H3.5a.75.75,0,0,1,0-1.5h17a.75.75,0,0,1,0,1.5Z",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M16,22.75H8c-3.65,0-5.75-2.1-5.75-5.75V8.5c0-3.65,2.1-5.75,5.75-5.75h8c3.65,0,5.75,2.1,5.75,5.75V17C21.75,20.65,19.65,22.75,16,22.75ZM8,4.25c-2.86,0-4.25,1.39-4.25,4.25V17c0,2.86,1.39,4.25,4.25,4.25h8c2.86,0,4.25-1.39,4.25-4.25V8.5c0-2.86-1.39-4.25-4.25-4.25Z",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M8.5,14.5a1,1,0,0,1-.38-.08.9.9,0,0,1-.54-.54,1,1,0,0,1-.08-.38,1.052,1.052,0,0,1,.29-.71,1.155,1.155,0,0,1,.33-.21.956.956,0,0,1,.58-.06.636.636,0,0,1,.18.06.757.757,0,0,1,.18.09l.15.12a1.576,1.576,0,0,1,.12.15.757.757,0,0,1,.09.18.636.636,0,0,1,.06.18,1.355,1.355,0,0,1,.02.2.99.99,0,0,1-1,1Z",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M12,14.5a1.052,1.052,0,0,1-.71-.29l-.12-.15a.757.757,0,0,1-.09-.18.636.636,0,0,1-.06-.18,1.355,1.355,0,0,1-.02-.2,1,1,0,0,1,.08-.38,1.155,1.155,0,0,1,.21-.33,1,1,0,0,1,1.09-.21,1.032,1.032,0,0,1,.33.21,1.052,1.052,0,0,1,.29.71,1.355,1.355,0,0,1-.02.2.636.636,0,0,1-.06.18.757.757,0,0,1-.09.18l-.12.15a1.032,1.032,0,0,1-.33.21,1,1,0,0,1-.38.08Z",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M8.5,18a1,1,0,0,1-.38-.08,1.155,1.155,0,0,1-.33-.21,1.032,1.032,0,0,1-.21-.33A1,1,0,0,1,7.5,17a1.052,1.052,0,0,1,.29-.71,1.155,1.155,0,0,1,.33-.21,1,1,0,0,1,1.09.21,1.576,1.576,0,0,1,.12.15.757.757,0,0,1,.09.18.6.6,0,0,1,.06.19A1.225,1.225,0,0,1,9.5,17a.99.99,0,0,1-1,1Z",
    fill: "#292d32"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.6f49daf6ca55c9f8c405f6598250f5ef.svg";
export { ForwardRef as ReactComponent };